import { ActionTypes } from "redux/reducers/specialUnits/types";
import { api_get, api_post, api_delete, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";
import { newDate } from "helpers/dateTools";

const { SET_SPECIAL_UNITS, SET_FILTERS, ADD_SPECIAL_UNIT, REMOVE_SPECIAL_UNIT } = ActionTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/special_unit_endowments`;

export const getSpecialUnits = (station, start, end) => async (dispatch, getState) => {
  if (!station?.id || !start || !end) return;
  dispatch(startRequestComp("loadingSpecialUnits"));
  try {
    const resp = await api_get(`${mainUrl}?idStation=${station.id}&start=${start}&end=${end}`);
    if (resp.length === 0) dispatch(setSnackbar("No se encontraron unidades especiales", "warning"));
    const unitsR = getState().unitsReducer.units;
    const units = resp.map(unit => ({
      ...unit,
      unit: unitsR[unit.idUnit]?.number || unit.idUnit,
      date: newDate({ date: unit.date }),
    }));
    dispatch({ type: SET_SPECIAL_UNITS, payload: units });
  } catch (error) {
    dispatch(setSnackbar(error, "danger"));
  } finally {
    dispatch(stopRequestComp("loadingSpecialUnits"));
  }
};

export const createSpecialUnit = (body, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("savingSpecialUnit"));
  try {
    const resp = await api_post(mainUrl, body);
    dispatch({ type: ADD_SPECIAL_UNIT, payload: {...resp, unit: body.unit} });
    dispatch(setSnackbar("Unidad especial creada", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("savingSpecialUnit"));
  }
};

export const deleteSpecialUnit = (id, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("savingSpecialUnit"));
  try {
    await api_delete(`${mainUrl}/${id}`);
    dispatch({ type: REMOVE_SPECIAL_UNIT, payload: id });
    dispatch(setSnackbar("Unidad especial eliminada", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error?.message || "Error al eliminar", "danger"));
  } finally {
    dispatch(stopRequestComp("savingSpecialUnit"));
  }
};

export const setSpecialUnitsFilters = (key = "", value) => ({
  type: SET_FILTERS,
  payload: { key, value },
});
